
(function(){
  if(window.__idBscSwatch)return;window.__idBscSwatch=1;
  document.addEventListener('click',function(e){
    var s=e.target&&e.target.closest&&e.target.closest('.id-bsc__sw');
    if(!s)return;
    e.preventDefault();e.stopPropagation();
    var card=s.closest('.id-bsc__card');
    if(!card)return;
    var img=card.querySelector('.id-bsc__media img');
    if(img){
      if(s.getAttribute('data-sw-src'))img.setAttribute('src',s.getAttribute('data-sw-src'));
      if(s.getAttribute('data-sw-srcset'))img.setAttribute('srcset',s.getAttribute('data-sw-srcset'));
    }
    var u=s.getAttribute('data-sw-url');
    if(u)card.setAttribute('href',u);
    ['price','monthly','compare'].forEach(function(key){
      var node=card.querySelector('[data-price-'+key+']');
      if(node)node.textContent=s.getAttribute('data-card-'+key)||'';
    });
    var from=card.querySelector('[data-price-from]');if(from)from.hidden=true;
    var available=s.getAttribute('data-card-available')==='true';
    var out=card.querySelector('[data-card-out]');if(out)out.hidden=available;
    var sale=card.querySelector('[data-card-sale]'),off=s.getAttribute('data-card-off');if(sale){sale.hidden=!available||!off;sale.textContent=off?'−'+off+'%':'';}

    var sibs=s.parentNode.querySelectorAll('.id-bsc__sw');
    for(var i=0;i<sibs.length;i++)sibs[i].classList.remove('is-on');
    s.classList.add('is-on');
  });
  document.addEventListener('keydown',function(e){if((e.key==='Enter'||e.key===' ')&&e.target.matches('.id-bsc__sw')){e.preventDefault();e.target.click();}});
})();
